// Production domain for stable link generation
// This ensures all client-facing links use the correct production URL
export const PRODUCTION_DOMAIN = "https://dashboard.creativeinvestments.africa";

// Canonical brand IDs (from public.business_brands). Used for embed/widget brand
// attribution where the widget runs anonymously and cannot look up brands by name.
export const BRAND_IDS = {
  COFFEEBEANS: "c395c2fa-4c12-4692-8814-560fa8885ce5",
  CREATIVE_TRAVEL_AFRICA: "ef0ce1ff-c11a-4641-9fa4-e6d9c2883670",
  SNAPSTACK: "6553ecb7-50d7-4895-9e49-3b6ba476075b",
  WEEKEND_SPECIALS: "f2d316db-18a9-4eeb-a740-1bf93ddf63af",
  AFRICAN_CREATIVE_INVESTMENTS: "6a676c6b-06df-43ef-bd25-99016de7f9cc",
} as const;

// Map a public ?brand= URL slug to a brand UUID for the booking widget.
export const BRAND_SLUG_TO_ID: Record<string, string> = {
  coffeebeans: BRAND_IDS.COFFEEBEANS,
  cta: BRAND_IDS.CREATIVE_TRAVEL_AFRICA,
  "creative-travel-africa": BRAND_IDS.CREATIVE_TRAVEL_AFRICA,
  "weekend-specials": BRAND_IDS.WEEKEND_SPECIALS,
};
